<template>
    <div id="key-points" class="bg-gray2 py-2 px-1 px-md-2" :class="!keyPoints[1] ? 'max-width-bloc' : ''">
        <div class="row text-center">
            <div class="col-12 pe-2" :class="keyPoints[1] ? 'col-md-6 key-point-block-border' : ''">
                <div class="h4 mb-auto" v-html="keyPoints[0].title" />
                <strong v-html="keyPoints[0].paragraph" />
                <hr v-if="keyPoints[1]" class="d-md-none my-2 separator separator--gray3">
            </div>

            <div v-if="keyPoints[1]" class="col-12 col-md-6 ps-2">
                <div class="h4 mb-auto" v-html="keyPoints[1].title" />
                <strong v-html="keyPoints[1].paragraph" />
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    keyPoints: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'ob1_variables';

@media (min-width: #{map-get($grid-breakpoints, md)}) {
  .key-point-block-border {
    border-right: 0.0625rem solid $gray-less-dark;
  }
}

</style>
